import { render, staticRenderFns } from "./EditFormField.vue?vue&type=template&id=ca64b810"
import script from "./EditFormField.vue?vue&type=script&lang=js"
export * from "./EditFormField.vue?vue&type=script&lang=js"
import style0 from "./EditFormField.vue?vue&type=style&index=0&id=ca64b810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports